<template>
  <v-dialog persistent max-width="900px" v-model="isDialogVisible">
    <v-btn
      color="primary"
      @click="resetForm"
      dark
      slot="activator"
      class="mb-2">
      Add Sponsor
    </v-btn>
    <v-card>
      <v-flex class="pt-4 text-xs-center">
        <v-card-title><h3>Logo image</h3></v-card-title>
        <v-card-media
          v-if="formData.logoUrl"
          :src="formData.logoUrl"
          height="200px"
          class="image-style"
        />
        <a-upload-section
          class="upload-button"
          :btnAppearance="btnAppearance"
          @lastUploadedPhotos="handlePhoto"
        />
        <v-btn
          :disabled="!formData.logoUrl"
           color="success"
           @click="formData.logoUrl = ''">
          Remove Image
        </v-btn>
        <v-chip
          v-if="isLogoImgError"
          label
          outline
          color="red">
          Image is required
        </v-chip>
      </v-flex>


      <v-flex class="pt-4 text-xs-center">
        <v-card-title><h3>Logo image (white)</h3></v-card-title>
        <v-card-media
          v-if="formData.logoWhiteUrl"
          :src="formData.logoWhiteUrl"
          height="200px"
          class="image-style"
        />
        <a-upload-section
          class="upload-button"
          :btnAppearance="btnAppearance"
          @lastUploadedPhotos="handleWhitePhoto"
        />
        <v-btn
          :disabled="!formData.logoWhiteUrl"
           color="success"
           @click="formData.logoWhiteUrl = ''">
          Remove Image
        </v-btn>
      </v-flex>


      <v-flex class="pt-4 text-xs-center">
        <v-card-title><h3>Person image</h3></v-card-title>
        <v-card-media
          v-if="formData.contactPerson.personPicture"
          :src="formData.contactPerson.personPicture"
          height="200px"
          class="image-style"
        />
        <a-upload-section
          class="upload-button"
          :btnAppearance="btnAppearance"
          @lastUploadedPhotos="handlePersonPhoto"
        />
        <v-btn
          :disabled="!formData.contactPerson.personPicture"
           color="success"
           @click="formData.contactPerson.personPicture = ''">
          Remove Image
        </v-btn>
      </v-flex>
      <v-card-title>
        <span class="headline"> {{formTitle}} </span>
      </v-card-title>
      <v-card-text>
        <v-form>
          <v-flex xs12>
            <div>
              <v-flex xs12>
                <content-field
                  label="Weight"
                  v-model="formData.weight"
                />
              </v-flex>
              <v-flex xs12>
                <content-field
                  label="Company"
                  v-model="formData.company"
                />
              </v-flex>
              <v-flex xs12>
                <v-select
                  autocomplete
                  :items="countries"
                  @change="setCountryCode"
                  v-model="formData.location"
                  label="Country"
                  item-value="name"
                  item-text="name"
                  :error="$v.formData.location"
                />
              </v-flex>
              <v-flex xs12>
                <v-card-title><h3>Description</h3></v-card-title>
                <content-editor
                  v-model="formData.description"
                />
              </v-flex>
              <v-flex xs12>
                <content-field
                  label="Link http://..."
                  v-model="formData.link"
                  :error="$v.formData.link"
                />
              </v-flex>
              <v-flex xs12>
                <content-field
                  label="Booth number"
                  v-model="formData.boothNumber"
                />
              </v-flex>
              <v-flex xs12 v-if="isWarningVisible">
                <v-card
                  outline
                  color="yellow lighten-5"
                  class="mb-3"
                >
                  <v-card-title >
                    <v-icon>warning</v-icon>
                    <h3>Warning:</h3>
                  </v-card-title>
                  <v-card-text>
                    <p>You've removed a type which is used in Sponsors Display Settings section.<br>
                      Don't forget to remove current sponsor from the section afterwards.</p>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-layout row>
                <v-flex xs12>
                  <h3>Sponsor Tiers: </h3>
                  <v-container fluid>
                    <div v-for="(tier, index) in sponsorsTiersList" :key="'tiersCheckboxes' + index">
                      <v-checkbox
                        :label="tier.title"
                        v-model="chosenSponsorTiers"
                        :value="tier.id"
                      ></v-checkbox>
                    </div>
                  </v-container>
                </v-flex>
                <v-flex xs12>
                  <h3>Sponsor Types: </h3>
                  <v-container fluid>
                    <div v-for="(type, index) in sponsorsTypeList" :key="'typesCheckboxes' + index">
                      <v-checkbox
                        :label="type.title"
                        v-model="chosenSponsorTypes"
                        :value="type.id"
                        :error="$v.chosenSponsorTypes.$error"
                        @change="checkIfWarningNeeded(type)"
                      ></v-checkbox>
                    </div>
                  </v-container>
                </v-flex>
                <v-flex xs12>
                  <h3>Sponsor Tags: </h3>
                  <v-container fluid>
                    <div v-for="(tag, index) in sellTags" :key="'tagsCheckboxes' + index">
                      <v-checkbox
                        :label="tag.displayName"
                        v-model="chosenSponsorTags"
                        :value="tag.id"
                        :error="$v.chosenSponsorTags.$error"
                      ></v-checkbox>
                    </div>
                  </v-container>
                </v-flex>
              </v-layout>
              <h3>Contact person information: </h3>
              <v-layout row>
                <v-flex xs3>
                  <content-field
                    label="Contact person name:"
                    v-model="formData.contactPerson.name"
                  />
                </v-flex>
                <v-flex xs3 offset-xs1>
                  <content-field
                    type="email"
                    label="Contact person email:"
                    v-model="formData.contactPerson.email"
                  />
                </v-flex>
                <v-flex xs3 offset-xs1>
                  <content-field
                    label="Contact person phone:"
                    v-model="formData.contactPerson.phone"
                  />
                </v-flex>
                <v-flex xs3 offset-xs1>
                  <content-field
                    label="Contact person position:"
                    v-model="formData.contactPerson.position"
                  />
                </v-flex>
              </v-layout>
            </div>
          </v-flex>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn color="error" dark large @click.stop="close">Cancel</v-btn>
        <v-btn color="success" dark large @click.stop="saveSponsor">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import { required, email, url } from 'vuelidate/lib/validators'
  import phoneNumberValidation from '@/utils/validators/isPhoneNumber'
  import AUploadSection from '@/components/shared/AUploadSection'
  import { mapActions, mapGetters } from 'vuex'
  import { path, compose, head, pathOr, clone, isEmpty } from 'ramda'
  import countries from '@/utils/countryCodes'

  export default {
    name: 'SponsorsFormModal',
    components: {
      AUploadSection
    },
    props: {
      fetchParam: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        countries,
        formData: {},
        isDialogVisible: false,
        editSponsorID: null,
        chosenSponsorTiers: [],
        chosenSponsorTypes: [],
        chosenSponsorTags: [],
        defaultFormData: {
          description: '',
          company: '0',
          company: '',
          location: '',
          logoUrl: '',
          logoWhiteUrl: '',
          link: '',
          tagsIds: [],
          sponsorTypesIds: [],
          sponsorTiersIds: [],
          contactPerson: {
            personPicture: '',
            email: '',
            name: '',
            phone: '',
            position: ''
          },
          boothNumber: '',
          metadata: {}
        },
        btnAppearance: {
          text: 'Choose Image',
          color: 'success',
          raised: true,
          hideIcon: true
        },
        isWarningVisible: false
      }
    },
    validations: {
      formData: {
        link: {
          required,
          url
        },
        logoUrl: { required },
        tagsIds: { required },
        // location: { required },
        sponsorTypesIds: { required },
        // contactPerson: {
        //   email: {
        //     required,
        //     email
        //   },
        //   name: { required },
        //   phone: {
        //     required,
        //     phoneNumberValidation
        //   }
        // }
      },
      chosenSponsorTypes: { required },
      chosenSponsorTags: { required }
    },
    computed: {
      ...mapGetters([
        'sponsorsTaskList',
        'sponsorsTypeList',
        'sponsorsTiersList',
        'sponsorsTagsList',
        'getSponsorsSettings'
      ]),
      sellTags () {
        if (this.sponsorsTagsList) {
          return this.sponsorsTagsList.filter(tag => typeof tag.type === 'string' && tag.type.match('Sell'))
        }
      },
      formTitle () {
        return this.editSponsorID ? 'Edit item' : 'New item'
      },
      isLogoImgError () {
        return path(['formData', 'logoUrl', '$error'], this.$v)
      }
    },
    methods: {
      ...mapActions([
        'createNewSponsor',
        'editSponsor',
        'fetchSponsorsList',
        'fetchSponsorTasksList',
        'fetchSponsorTypesList',
        'fetchSponsorTiersList',
        'fetchSponsorsTagsList'
      ]),
      async saveSponsor () {
        try {
          this.$v.$touch()
          this.formObjectToSave()
          if (this.$v.$invalid) return
          const submitMethod = this.editSponsorID
            ? this.editSponsor
            : this.createNewSponsor
          const payload = clone(this.formData)
          if (isEmpty(payload.link)) {
            payload.link = null
          }
          await submitMethod(payload)
          this.fetchSponsorsList(this.fetchParam)
          this.isDialogVisible = false
        } catch (err) {
          console.error(err)
        }
      },
      resetForm () {
        this.editSponsorID = null
        this.formData = clone(this.defaultFormData)
        this.chosenSponsorTiers = []
        this.chosenSponsorTypes = []
        this.chosenSponsorTags = []
        this.$v.$reset()
      },
      close () {
        this.isDialogVisible = false
        this.editSponsorID = null
      },
      handlePhoto (photos) {
        const choseUrl = (urls) => urls.small || urls.medium || urls.large || urls.originalImageUrl
        this.formData.logoUrl = compose(choseUrl, pathOr({}, ['imagesUrls']), head)(photos)
      },
      handleWhitePhoto (photos) {
        const choseUrl = (urls) => urls.small || urls.medium || urls.large || urls.originalImageUrl
        this.formData.logoWhiteUrl = compose(choseUrl, pathOr({}, ['imagesUrls']), head)(photos)
      },
      handlePersonPhoto (photos) {
        const choseUrl = (urls) => urls.small || urls.medium || urls.large || urls.originalImageUrl
        this.formData.contactPerson.personPicture = compose(choseUrl, pathOr({}, ['imagesUrls']), head)(photos)
        this.$store.dispatch('SET_SPINNER_STATUS', false) // to apply changes on store (async upload)
      },
      formObjectToSave () {
        this.formData.sponsorTiersIds = this.chosenSponsorTiers
        this.formData.sponsorTypesIds = this.chosenSponsorTypes
        this.formData.tagsIds = this.chosenSponsorTags
      },
      checkIfWarningNeeded (type) {
        if(!this.editSponsorID) return
        const typeId = type.id
        if (this.checkIfTypeDeselected(typeId)) {
          const matchingSection = this.checkSectionExistance(typeId)
          const isWarningVisible = !!matchingSection && !!this.checkIfIncludesCurrentSponsor(matchingSection)
          this.showWarning(isWarningVisible)
        } else {
          this.showWarning(false)
        }
      },
      checkIfTypeDeselected (typeId) {
        return !this.chosenSponsorTypes.includes(typeId) // check if item was deselected
      },
      checkSectionExistance (typeId) {
        return this.getSponsorsSettings.sections.find((section)=>{
          return section.id === typeId
        })
      },
      checkIfIncludesCurrentSponsor (matchingSection) {
        return matchingSection.sponsors.some((sponsor) => sponsor.id === this.editSponsorID)
      },
      showWarning (visibilityStatus) {
        this.isWarningVisible = visibilityStatus
      },
      setCountryCode (country) {
        const chosenCountry = countries.find(item => {
          return country === item.name
        })
        this.formData.countryCode = formData.code
      },
    },
    created () {
      this.$bus.$on('editSponsor', sponsor => {
        this.editSponsorID = sponsor.id
        this.formData = clone(sponsor)
        this.isDialogVisible = true
        this.chosenSponsorTiers = sponsor.sponsorTiersIds || []
        this.chosenSponsorTypes = sponsor.sponsorTypesIds || []
        this.chosenSponsorTags = sponsor.tags || []
      })
      this.formData = clone(this.defaultFormData)
    }
  }
</script>

<style>
  .image-style {
    width: 500px;
    margin: 0 auto;
  }

  .card__media__background {
    background-size: contain !important;
  }

  .upload-button {
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Sponsors/SponsorsList/formModal.vue